// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The one dark pop-up menu: a browse card's right-click menu (CardContextMenu)
   and the top bar's menus (HeaderMenu) wear the same panel and rows. They used
   to be two designs, and the bar's had square corners and an orange hover with
   white text on it. Position is the caller's: a context menu sits at the
   pointer, a bar menu under its trigger. */

.B2DiOGCDhuZoW5vo_Ga8 {
  background-color: var(--curio-top-bar-bg);
  border: 1px solid var(--curio-border-context-menu);
  border-radius: var(--curio-radius-sm);
  box-shadow: var(--curio-shadow-context-menu);
  min-width: 160px;
  padding: 4px 0;
  font-family: var(--curio-font-family);
}

/* Rows are <button>s (or the odd <a>), so the browser's own chrome is reset
   here rather than left to Bootstrap's reboot, which the canvas loads. */
.KM9f6VD2qbZkpb3LUa3F {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin: 0;
  text-align: left;
  background: none;
  border: none;
  border-radius: 0;
  padding: 8px 16px;
  color: var(--curio-text-on-dark);
  font-family: inherit;
  font-size: var(--curio-font-size-md);
  font-weight: 400;
  line-height: 1.4;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}

.KM9f6VD2qbZkpb3LUa3F:hover:not(:disabled),
.KM9f6VD2qbZkpb3LUa3F:focus-visible {
  background-color: var(--curio-top-bar-bg-hover);
  color: var(--curio-text-on-dark);
  text-decoration: none;
}

.KM9f6VD2qbZkpb3LUa3F:focus-visible {
  outline: 2px solid var(--curio-focus-ring);
  outline-offset: -2px;
}

.KM9f6VD2qbZkpb3LUa3F:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.aUNcZusOgZ7IKs0B0T4H {
  color: var(--curio-danger);
}

.aUNcZusOgZ7IKs0B0T4H:hover:not(:disabled) {
  color: var(--curio-danger);
}

/* A fixed-width glyph column, so the labels line up whatever the icon. */
.vDPXlAQEM08B1oJosg0b {
  width: 14px;
  flex-shrink: 0;
  color: var(--curio-text-on-dark-muted);
}

/* A setting's On or Off, at the row's end. */
.AZp6T7UQRHtovqQbSDI5 {
  margin-left: auto;
  padding-left: 16px;
  color: var(--curio-text-on-dark-muted);
}

.NhdvzmlQ3C0aexfPfpKg {
  height: 1px;
  margin: 4px 0;
  background-color: var(--curio-border-context-menu);
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/darkMenu.module.css"],"names":[],"mappings":"AAAA;;;;2CAI2C;;AAE3C;EACE,yCAAyC;EACzC,kDAAkD;EAClD,qCAAqC;EACrC,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;yEACyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,+CAA+C;EAC/C,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,cAAc;EACd,sCAAsC;AACxC;;AAEA,6CAA6C;AAC7C;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kDAAkD;AACpD","sourcesContent":["/* The one dark pop-up menu: a browse card's right-click menu (CardContextMenu)\n   and the top bar's menus (HeaderMenu) wear the same panel and rows. They used\n   to be two designs, and the bar's had square corners and an orange hover with\n   white text on it. Position is the caller's: a context menu sits at the\n   pointer, a bar menu under its trigger. */\n\n.panel {\n  background-color: var(--curio-top-bar-bg);\n  border: 1px solid var(--curio-border-context-menu);\n  border-radius: var(--curio-radius-sm);\n  box-shadow: var(--curio-shadow-context-menu);\n  min-width: 160px;\n  padding: 4px 0;\n  font-family: var(--curio-font-family);\n}\n\n/* Rows are <button>s (or the odd <a>), so the browser's own chrome is reset\n   here rather than left to Bootstrap's reboot, which the canvas loads. */\n.item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  margin: 0;\n  text-align: left;\n  background: none;\n  border: none;\n  border-radius: 0;\n  padding: 8px 16px;\n  color: var(--curio-text-on-dark);\n  font-family: inherit;\n  font-size: var(--curio-font-size-md);\n  font-weight: 400;\n  line-height: 1.4;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.item:hover:not(:disabled),\n.item:focus-visible {\n  background-color: var(--curio-top-bar-bg-hover);\n  color: var(--curio-text-on-dark);\n  text-decoration: none;\n}\n\n.item:focus-visible {\n  outline: 2px solid var(--curio-focus-ring);\n  outline-offset: -2px;\n}\n\n.item:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.itemDestructive {\n  color: var(--curio-danger);\n}\n\n.itemDestructive:hover:not(:disabled) {\n  color: var(--curio-danger);\n}\n\n/* A fixed-width glyph column, so the labels line up whatever the icon. */\n.itemIcon {\n  width: 14px;\n  flex-shrink: 0;\n  color: var(--curio-text-on-dark-muted);\n}\n\n/* A setting's On or Off, at the row's end. */\n.itemState {\n  margin-left: auto;\n  padding-left: 16px;\n  color: var(--curio-text-on-dark-muted);\n}\n\n.divider {\n  height: 1px;\n  margin: 4px 0;\n  background-color: var(--curio-border-context-menu);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `B2DiOGCDhuZoW5vo_Ga8`,
	"item": `KM9f6VD2qbZkpb3LUa3F`,
	"itemDestructive": `aUNcZusOgZ7IKs0B0T4H`,
	"itemIcon": `vDPXlAQEM08B1oJosg0b`,
	"itemState": `AZp6T7UQRHtovqQbSDI5`,
	"divider": `NhdvzmlQ3C0aexfPfpKg`
};
export default ___CSS_LOADER_EXPORT___;
